export interface DeleteCaddyProps {
  caddyNumber: string;
  onCancel: () => void;
  onDelete: () => void;
}
